import { render, staticRenderFns } from "./EducationMenuItem.vue?vue&type=template&id=2c74196a&scoped=true"
import script from "./EducationMenuItem.vue?vue&type=script&lang=js"
export * from "./EducationMenuItem.vue?vue&type=script&lang=js"
import style0 from "./EducationMenuItem.vue?vue&type=style&index=0&id=2c74196a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c74196a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GbLink: require('/builds/gb-developers/geekbrains-client/components/global/GbLink/GbLink.vue').default})
